import { useContext } from 'react';

import { GlobalMobileContext } from '../contexts/globalMobileContext';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { byPrefixAndName } from '@awesome.me/kit-fe6b9b7683/icons'

import { sortNotesByUpdatedAt } from '../utils/UtilitaryFunctions';
import styles from './Mobile_HeaderComponent.module.css'

const Mobile_HeaderComponent = () => {

    const {
        setCurrentPage, currentPage, setCurrentProject, setLogOutPopup, setCurrentConference, inputNoteRef, currentConference, currentNote, setCurrentNote,
        setCurrentNotesList, setCurrentError, mobileSocketRef, currentUser
    } = useContext(GlobalMobileContext);

    const goBack = () => {
        if (currentPage === "Conferences") {
            setCurrentPage("Projects")
        } else if (currentPage === "Conference menu") {
            setCurrentPage("Conferences")
        } else if (currentPage === "Notes" || currentPage === "Topics") {
            setCurrentPage("Conference menu")
        } else if (currentPage === "NotesEdit") {
            addEntity()
        }

    };

    const goToPage = (newPage) => {
        if (newPage === "Projects") {
            setCurrentProject(null)
            setCurrentConference(null)
        }
        setCurrentPage(newPage);
    }

    const logOut = () => {
        setLogOutPopup(true)
    }

    const addEntity = () => {
        if (inputNoteRef.current.value && inputNoteRef.current.value !== "") {
            mobileSocketRef.current.emit("MOBILE_CONFERENCE_UPDATE_NOTE", currentNote?._id, currentConference?._id, currentUser?._id, inputNoteRef.current.value, (callback) => {
                if (!callback.error) {
                    let notes = sortNotesByUpdatedAt(callback.response)
                    setCurrentNotesList(notes)

                    setCurrentNote(null);
                    inputNoteRef.current.value = "";

                    setCurrentPage("Notes")
                } else {
                    setCurrentError(callback.error)
                }
            });
        } else {
            setCurrentNote(null);
            inputNoteRef.current.value = "";

            setCurrentPage("Notes")
        }

    }



    return (

        <header id="header" className={styles.header} style={{ backgroundColor: currentPage === "NotesEdit" ? "#435B68" : "#050020" }}>

            <div className={styles.row}>
                {currentPage !== "NotesEdit" && <button className={styles.btn} onClick={() => goToPage("Projects")}
                    style={{ color: currentPage === "Projects" ? "white" : "#E4E4E4", opacity: currentPage === "Projects" ? 1 : 0.5, }}>
                    <FontAwesomeIcon icon={byPrefixAndName.fal['house']} style={{ fontSize: 24 }} />
                </button>}

                {currentPage && currentPage !== "Projects" && (
                    <button className={styles.btn} onClick={goBack}
                        style={{ marginLeft: currentPage === "NotesEdit" ? "0px" : "16px" }}>
                        <FontAwesomeIcon icon={byPrefixAndName.fal['arrow-left']} style={{ fontSize: 24, padding: 0 }} />
                    </button>
                )}
            </div>

            <div className={styles.row}>
                {currentPage !== "NotesEdit" && <button className={styles.btn} onClick={logOut}
                    style={{ color: currentPage === "Projects" ? "white" : "#E4E4E4", opacity: currentPage === "Projects" ? 1 : 0.5, marginRight: "0px" }}>
                    <FontAwesomeIcon icon={byPrefixAndName.fal['arrow-right-from-bracket']} style={{ fontSize: 24, padding: 0 }} />

                </button>}
            </div>

        </header>

    );
}

export default Mobile_HeaderComponent;